const namespaced = true

const state = {
	customer: '',
	year: '',
	order: null,
}

const getters = {
	customer_id: state => { return state.customer.id },
	year: state => { return state.year },
	order: state => { return state.order },

	customer: state => {
		return state.customer
	}
}

const actions = {
	SET_CUSTOMER({ commit }, customer) {
		commit('setCustomer', customer)
	},

	CLEAR_CUSTOMER({ commit }) {
		commit('clearCustomer')
	},

	SET_YEAR({ commit }, year) {
		commit('setYear', year)
	},

	CLEAR_YEAR({ commit }) {
		commit('clearYear')
	},

	SET_ORDER({ commit }, order) {
		commit('setOrder', order)
	},
}

// mutations
const mutations = {
	setCustomer(state, customer) {
		state.customer = customer
	},

	clearCustomer(state) {
		state.customer = ''
	},

	setYear(state, year) {
		state.year = year
	},

	clearYear(state) {
		state.year = ''
	},

	setOrder(state, order) {
		state.order = order
	},
}

export default {
	namespaced,
	state,
	getters,
	actions,
	mutations
}